<template>
  <div>
    <cReviewHotel
      :hotelObj="sHotelObj"
      :isToggleOption="true"
      :isEditOption="true"
      :isShowLeftPart="true"
      :isHideDetails="true"
    />
    <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
      <CRow class="flex-flow-column">
        <CCol>
          <span>{{ $t("tariffList.title") }}</span>
        </CCol>

        <p class="desc">{{ $t("tariffList.desc") }}</p>
      </CRow>
      <CButton
        @click="navToNew(null)"
        size="sm"
        color="success"
        class="ml-auto btn-lit-blue mob-w100"
      >{{ $t("tariffList.add") }}</CButton>
    </CCardHeader>
    <div class="card assign pricing-card">
    <div class="w-100 max-w-900 m-auto ">
      <cRoomInfoBox
        v-if="isRebuildCRoomInfoBox"
        :hotelObj="sHotelObj"
        :roomObj="sRoomObj"
        @getSelRatePlan="getSelectedRatePlan"
      />
    </div>
    <div v-if="selRatePlan">
      <div v-if="listTariff&&listTariff.length>0">
        <CCardBody
          class="card assign pricing-card"
          v-for="(tariff,index) in listTariff"
          :key="index"
        >
          <table>
            <thead>
              <tr>
                <th>
                  <span>{{$t("tariffList.stayFrom")}}</span>
                </th>
                <th>
                  <span>{{$t("tariffList.stayTo")}}</span>
                </th>
                <th>
                  <span>{{$t("tariffList.singleOccupancyFare")}}</span>
                </th>
                <th>
                  <span>{{$t("tariffList.doubleOccupancyFare")}}</span>
                </th>
                <th>
                  <span>{{$t("tariffList.fullOccupancyFare")}}</span>
                </th>
                <th>
                  <span>{{$t("tariffList.cutOffDays")}}</span>
                </th>
                <th>
                  <span>{{$t("tariffList.applicableDays")}}</span>
                </th>
                <th>
                  <span></span>
                </th>
                <th>
                  <span></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr      @click.stop="navToNew(tariff)">
                <td>
                  <div v-if="tariff.stayfrom">
                    <div>{{tariff.stayfrom|formatDate(DATE_TIME_FORMAT.REPORT_DATE_FORMAT)}}</div>
                  </div>
                  <div v-else>{{'-'}}</div>
                </td>
                <td>
                  <div v-if="tariff.stayto">
                    <div>{{tariff.stayto|formatDate(DATE_TIME_FORMAT.REPORT_DATE_FORMAT)}}</div>
                  </div>
                  <div v-else>{{'-'}}</div>
                </td>
                <td>
                  <div v-if="tariff.singleOccupancyFare||(tariff.cutoffdays==0||tariff.cutoffdays=='0')">
                    <div> {{ selRatePlan && selRatePlan.currency ?selRatePlan.currency:''}}   {{  tariff.singleOccupancyFare | formatNumber(selRatePlan.currency) }}</div>
                  </div>
                  <div v-else>{{'-'}}</div>
                </td>
                <td>
                  <div v-if="tariff.doubleOccupancyFare||(tariff.cutoffdays==0||tariff.cutoffdays=='0')">
                    <div>{{ selRatePlan && selRatePlan.currency ?selRatePlan.currency:''}}   {{tariff.doubleOccupancyFare | formatNumber(selRatePlan.currency)}}</div>
                  </div>
                  <div v-else>{{'-'}}</div>
                </td>
                <td>
                  <div v-if="tariff.fullOccupancyFare||(tariff.cutoffdays==0||tariff.cutoffdays=='0')">
                    <div>{{ selRatePlan && selRatePlan.currency ?selRatePlan.currency:''}}    {{tariff.fullOccupancyFare | formatNumber(selRatePlan.currency)}}</div>
                  </div>
                  <div v-else>{{'-'}}</div>
                </td>
                <td>
                  <div v-if="tariff.cutoffdays||(tariff.cutoffdays==0||tariff.cutoffdays=='0')">
                    <div>{{tariff.cutoffdays}}</div>
                  </div>
                  <div v-else>{{'-'}}</div>
                </td>
                <td>
                  <div v-if="tariff.applicableDays.length==7">
                    <div>{{$t("tariffList.allDays")}}</div>
                  </div>
                  <div v-else-if="tariff.applicableDays">
                    <span >{{tariff.applicableDays+''}}</span>
                  </div>
                  <div v-else>{{'-'}}</div>
                </td>
                <td>
                  <CRow>
                    <CCol>
                      <div
                        v-if="permission.canEdit"
                        @click.stop="navToNew(tariff)"
                        col="2.5"
                        class="edit-icon icon-25px c-pointer"
                        color="info removewrap"
                        v-c-tooltip.hover="{ content: $t('tariffList.edit') , active:false }"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="512pt"
                          viewBox="0 0 512 512"
                          width="512pt"
                          style="fill:#3c4b64;"
                        >
                          <path
                            d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                          />
                          <path
                            d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                          />
                          <path
                            d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                          />
                        </svg>
                      </div>
                    </CCol>

                    <CCol>
                      <div
                        v-if="permission.canDelete"
                        @click.stop="onConfirmDeleteTariff(tariff)"
                        col="2.5"
                        size="sm"
                        color="danger"
                        v-c-tooltip.hover="{ content: $t('tariffList.delete') , active:false }"
                        class="icon-25px c-pointer"
                      >
                        <CIcon style="color: #cd0606;font-size:22px;" name="cil-trash" size="lg"></CIcon>
                      </div>
                    </CCol>
                  </CRow>
                </td>
              </tr>
            </tbody>
          </table>
        </CCardBody>
      </div>
      <div v-else class="text-center my-5">
             <div v-if="isLoading" class="text-center my-5">
                <div  data-v-211fa86d="" role="status" aria-hidden="false" class="spinner-grow spinner-grow-lg text-primary" aria-label="Loading"></div>
         </div>
        <span v-else>{{$t('tariffList.tariffEmpty')}}</span>
      </div>
     
    </div>
     
    </div>
    <CButton @click="navToPrevPage"
                color="danger"
              
                class="action-c-btn"
              >{{ $t('tariffList.back')}}</CButton>
    <cAlertModal
      v-if="isShowAlertModal"
      :key="'tariffAll'+alertCount"
      :buttonList="modalButton"
      :status="modalStatus"
      :isShowIcon="true"
      :show="isShowAlertModal"
      :desc="confirmTxt"
    ></cAlertModal>
  </div>
</template>
<script>
import cReviewHotel from "../../../../../components/hms/cReviewHotel";
import router, { navigate, goBack } from "../../../../../router/index";
import {
  COMPONENT_NAME,
  PATHNAME,
  ALERT_MODAL_STATUS,
  DATE_TIME_FORMAT
} from "../../../../../util/constants";
import BaseConfiguration from "../../../../../config/base.js";
import Logger from "../../../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "../../../../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";
import cRoomInfoBox from "../../../../../components/hms/manage/hotelInfo/cRoomInfoBox";
import apiGetHotelTariff from "../../../../../services/apiGetHotelTariff";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../../../util/apiValidate";
import { getErrorAlertValue, handleJWT } from "../../../../../util/util";
import cAlertModal from "../../../../../components/form/cAlertModal";
import Vue from "vue";
import apiDeleteHotelTariff from "../../../../../services/apiDeleteHotelTariff";

export default {
  name: COMPONENT_NAME.TARIFF_ALL,

  components: {
    cReviewHotel,
    cRoomInfoBox,
    cAlertModal
  },
  data: () => {
    return {
      selRatePlan: null,
      listTariff: [],
      permission: null,
      alertCount: 0,
      modalStatus: ALERT_MODAL_STATUS.INFO,
      modalButton: null,
      isShowAlertModal: false,
      confirmTxt: null,
      alertCount: 0,
      isRebuildCRoomInfoBox: true,
      selTariffObj: null,
      isLoading:true,
    };
  },
  computed: {
    ...mapGetters("shmsManage", {
      sHotelObj: "GET_SEL_HOTEL"
    }),
    ...mapGetters("sHotelInfo", {
      sRoomObj: "GET_HOTEL_ROOM_OBJ"
    }),
    DATE_TIME_FORMAT() {
      return DATE_TIME_FORMAT;
    }
  },
  created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.TARIFF_ALL,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  methods: {
    ...mapActions("sTariff", {
      SET_SEL_TARIFF: "SET_SEL_TARIFF",
      SET_TARIFF_REQ: "SET_TARIFF_REQ"
    }),
    navToPrevPage() {
        try {
          if(BaseConfiguration.isDebug) console.log("navToPrevPage");
         goBack();
    
        } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.MANAGE_ALL,
                  "error in navToPrevPage",
                  err.toString(),
                  "navToPrevPage",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
    showAlertModal(status, val) {
      this.isShowAlertModal = true;
      this.alertCount += 1;
      this.modalStatus = status;
      this.confirmTxt = val;

      if (status == ALERT_MODAL_STATUS.INFO) {
        this.modalButton = [
          {
            name: this.$t("tariffList.noBtn"),
            func: this.toggleShowAlertModal
          },
          {
            name: this.$t("tariffList.yesBtn"),
            func: this.onDeleteTariff
          }
        ];
      } else if (status == ALERT_MODAL_STATUS.SUCCESS) {
        this.modalButton = [
          {
            name: this.$t("tariffList.okBtn"),
            func: this.onSuccessDelete
          }
        ];
      } else if (status == ALERT_MODAL_STATUS.FAIL) {
        this.modalButton = [
          {
            name: this.$t("tariffList.okBtn"),
            func: this.toggleShowAlertModal
          }
        ];
      }
    },
    toggleShowAlertModal() {
      this.isShowAlertModal = !this.isShowAlertModal;
    },
    onSuccessDelete() {
      try {
        if (BaseConfiguration.isDebug) console.log("onSuccessDelete");
        this.isShowAlertModal = false;
        this.isRebuildCRoomInfoBox = false;
        let that = this;
        Vue.nextTick(function() {
          that.isRebuildCRoomInfoBox = true;
        });
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in onSuccessDelete",
          err.toString(),
          "onSuccessDelete",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async onDeleteTariff() {
      try {
        if (BaseConfiguration.isDebug) console.log("onDeleteTariff");
        if (this.selTariffObj && this.selTariffObj.tariffid) {
          let hotelDeleteRes = await this.deleteTariff(
            this.sHotelObj.hotelid,
            this.selTariffObj.tariffid
          );
          if (hotelDeleteRes) {
            this.showAlertModal(
              ALERT_MODAL_STATUS.SUCCESS,
              this.$t("tariffList.deleteTariffSuccDesc")
            );
          } else {
            this.showAlertModal(ALERT_MODAL_STATUS.FAIL, this.alertValue);
          }
        } else {
          throw "invalid hotelid";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in onDeleteTariff",
          err.toString(),
          "onDeleteTariff",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async deleteTariff(pHotelId, pTariffId) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("deleteTariff");
        let tariffReq = apiDeleteHotelTariff.buildRequest(pHotelId, pTariffId);

        if (tariffReq) {
          let hotelRes = await apiDeleteHotelTariff.getResponse(tariffReq);

          if (VALIDATE_SUCCESS_RES(hotelRes)) {
            this.alertValue = null;
            retValue = hotelRes.data.data;
          } else {
            let error = getErrorMessage(hotelRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error, true, true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in deleteTariff",
          err.toString(),
          "deleteTariff",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    onConfirmDeleteTariff(pTariffObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onConfirmDeleteTariff");
        this.selTariffObj = pTariffObj;
        this.showAlertModal(
          ALERT_MODAL_STATUS.INFO,
          this.$t("tariffList.deleteTariffConfirmation")
        );
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in onConfirmDeleteTariff",
          err.toString(),
          "onConfirmDeleteTariff",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async getSelectedRatePlan(pRatePlan) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelectedRatePlan");
        this.isLoading=true;
        this.listTariff=[];
        this.selRatePlan = pRatePlan;
        if (this.sHotelObj && this.sRoomObj && this.selRatePlan) {
          let lsTariff = await this.getHotelTariffList(
            this.sHotelObj.hotelid,
            this.sRoomObj.roomid,
            this.selRatePlan.id
          );
          if (lsTariff) {
            this.listTariff = lsTariff;
          }
          this.isLoading=false;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in getSelectedRatePlan",
          err.toString(),
          "getSelectedRatePlan",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async getHotelTariffList(pHotelId, pRoomId, pRatePlan) {
      let returnValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getHotelTariffList");

        let fareRuleReq = apiGetHotelTariff.buildRequest(
          pHotelId,
          pRoomId,
          pRatePlan
        );

        if (fareRuleReq) {
          this.SET_TARIFF_REQ(fareRuleReq);
          let fareRuleRes = await apiGetHotelTariff.getResponse(fareRuleReq);
          if (VALIDATE_SUCCESS_RES(fareRuleRes)) {
            this.alertValue = null;
            returnValue = fareRuleRes.data.data.list;
            this.permission = fareRuleRes.data.data.permission;
          } else {
            let error = getErrorMessage(fareRuleRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_RULE_ALL,
          "error in  getHotelTariffList",
          err.toString(),
          "getHotelTariffList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },
    navToNew(pTariffObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("navToNew");
        if (pTariffObj) {
          this.SET_SEL_TARIFF(pTariffObj);
        } else {
          this.SET_SEL_TARIFF(null);
        }
        navigate(PATHNAME.TARIFF_NEW);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TARIFF_ALL,
          "error in navToNew",
          err.toString(),
          "navToNew",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  }
};
</script>